import React, { Component } from 'react';
import { withRouter } from '../../withRouter';
import { getCookie, setCookie } from 'helpers/cookies'
import { connect, } from 'react-redux';
import Form from 'react-bootstrap/Form';
import KickstarterBadge from 'images/Promotions/kickstarter-badge.png';
import DONDBannerImg from 'images/Promotions/dond-banner.png';
import kickstarterLogo from 'images/kickstarter-logo.png';

import styles from 'components/Modals/KickstarterModal/KickstarterModal.module.scss';
import cross from 'images/icons/Cross.png'

const shopPath = "deal-or-no-deal";
const cookieAccepted = `kickstarter-${shopPath}-accepted`;
const cookieShow = `kickstarter-${shopPath}-show`;
const cookieDontShow = `kickstarter-${shopPath}-dont-show`;
const gameCode = "dond";
const kickstarterURL = "";
class CRMModal extends Component {

    constructor(props) {
        super(props);

        this.state = {
            enabled: true,
            show: false,
        };
    }


    componentDidMount() {
        const accepted = getCookie(cookieAccepted);
        const dontShow = getCookie(cookieDontShow);
        if (accepted) setCookie(cookieAccepted, true, 400); // keeps the cookie alive (provided they return in 400 days)
        const ownsGame = this.props.auth?.user?.games?.some(g => g.code === gameCode);
        const shouldShow = !accepted && !dontShow && !ownsGame;
        this.setState({ accepted: accepted, dontShow: dontShow, enabled: shouldShow, show: shouldShow });
    }

    buyNow = (e) => {
        if (!this.state.show) return;
        e.preventDefault();
        setCookie(cookieAccepted, true, 400);
        this.setState({ show: false });
        setTimeout(() => {
            this.setState({ enabled: false });
        }, 500);
        this.props.navigate(`/shop/${shopPath}?&utm_source=website&utm_medium=banner&utm_campaign=kickstarter-popup`);
    }

    close = () => {
        if (!this.state.show) return;
        setCookie(cookieDontShow, true, 7);
        this.setState({ show: false });
        setTimeout(() => {
            this.setState({ enabled: false });
        }, 500);
    }

    dontShow = () => {
        setCookie(cookieDontShow, true, 30);
    }


    openInNewTab(e, url) {
        if (!this.state.show) return;
        e.preventDefault();
        setCookie(cookieAccepted, true, 400);
        this.setState({ show: false });
        setTimeout(() => {
            this.setState({ enabled: false });
        }, 500);
        window.open(url, '_blank').focus();
    }


    render() {
        return <React.Fragment>
            {this.state.enabled && window.location.pathname !== "roku" &&
                <div className={`${styles.screenOverlay} ${this.state.show && styles.show} ${this.props.styles}`} >
                    <div className={styles.screenOverlayBG}></div>
                    <div className={styles.modalContainer} >
                        <img className={styles.newGameImg} src={KickstarterBadge} alt="kickstarter" />
                        <Form onSubmit={(e) => this.openInNewTab(e, "https://www.kickstarter.com/projects/1169339123/1485717407?ref=djv456")} className={styles.modal} >
                            <button type="button" className={styles.closeButton} onClick={this.close} >
                                <img src={cross} alt="close-button" />
                            </button>
                            <img className={styles.gameHighlightImg} src={DONDBannerImg} alt="deal or no deal" />
                            <p className={`${styles.banner}`} >
                                <span className={styles.gameTitle}>COMING SOON</span>
                            </p>
                            <div className={styles.textContainer} >
                               
                                <p className={styles.description} >
                                    BE THE FIRST TO PLAY A MODERN TWIST ON THE LEGENDARY TV GAME DEAL OR NO DEAL - VOICE CONTROL, LEADERBOARDS AND BIG DECISIONS INCLUDED
                                </p>
                            </div>

                            <div className={styles.signUp} >
                                <div className={styles.buttonWrapper} >
                                    <button className={`${styles.button} ${styles.kickstarter}`} type="submit" >
                                        FIND OUT MORE ON
                                        <br />
                                        <img src={kickstarterLogo} className={styles.kickstarterLogo}></img>
                                    </button>
                                </div>
                            </div>

                            <div className={styles.dontShow} >
                                <a className={`${styles.link}`} onClick={this.close} >Don't show this again</a>
                            </div>
                        </Form>
                    </div>
                </div>
            }
        </React.Fragment>
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        pricing: state.pricing,
    };
}

export default connect(mapStateToProps)(withRouter(CRMModal));